import { Plus, Trash2, UserCircle } from '@digital-twins/design-system/icons'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface GuestEntry {
  id: string
  email: string
  expiresAt: string
}

interface GuestListProps {
  guests: Array<GuestEntry>
  orgMemberEmails?: Set<string>
  onRemove?: (guestId: string) => void
  onAddToOrg?: (email: string) => void
  className?: string
}

export function GuestList({ guests, orgMemberEmails, onRemove, onAddToOrg, className }: GuestListProps) {
  if (guests.length === 0) return null

  return (
    <div className={cn('flex flex-col gap-1', className)}>
        {guests.map((guest) => {
          const isInOrg = orgMemberEmails?.has(guest.email.toLowerCase())
          return (
            <div key={guest.id} className="flex items-center justify-between py-1.5">
              <div className="flex items-center gap-2.5 min-w-0">
                {!isInOrg && onAddToOrg ? (
                  <TooltipProvider delayDuration={200}>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <button
                          type="button"
                          data-testid={`add-to-org-${guest.id}`}
                          onClick={() => onAddToOrg(guest.email)}
                          className="flex h-7 w-7 items-center justify-center rounded-full border border-dashed border-primary text-primary hover:bg-primary/10 transition-colors flex-shrink-0"
                        >
                          <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
                        </button>
                      </TooltipTrigger>
                      <TooltipContent side="top" className="max-w-[220px] text-center">
                        Add this user to your organization to earn 300 credits
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                ) : (
                  <UserCircle className="w-7 h-7 text-muted-foreground flex-shrink-0" strokeWidth={1.5} />
                )}
                <span className="text-sm text-foreground truncate">{guest.email}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm text-muted-foreground">Guest</span>
                {onRemove && (
                  <button
                    type="button"
                    onClick={() => onRemove(guest.id)}
                    className="text-muted-foreground hover:text-destructive transition-colors p-0.5"
                  >
                    <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                  </button>
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}
